import React from 'react';
import Button from '../../../../components/Button';
import cx from 'classnames';
import styles from '../../ContactForm.module.scss';
import { TABS, TabName } from '../tabConfig';

interface TabNavigationProps {
    activeTab: TabName;
    onTabChange: (tab: TabName) => void;
    onSave: () => Promise<void>;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange, onSave }) => {
    return (
        <div className={cx(styles['tab-navigation'])}>
            <nav className={cx(styles['tab-nav'], 'zr-d-flex')}>
                {TABS.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => onTabChange(tab)}
                        className={cx(
                            styles['tab-button'],
                            'zr-py-2',
                            'zr-px-3',
                            { [styles.active]: activeTab === tab }
                        )}
                    >
                        {tab}
                    </button>
                ))}
            </nav>

            <div className={cx(styles['tab-actions'])}>
                <Button
                    hierarchy="primary"
                    text="Alle Einstellungen speichern"
                    fn={onSave}
                    classes={cx(styles['save-button'])}
                />
            </div>
        </div>
    );
};


